import type { Point } from './camera';
import type { Side } from './connectors';
import type { OBB } from './geometry';
import { toWorld } from './handles';

/** "+" buttons around a selected sticky note (click one to add a neighbor): constant screen offset out of each side. */
export const PLUS_OFFSET_PX = 48; // beyond the rotate handle (24 px) and the anchor dots (12 px)
const PLUS_HIT_PX = 10;
const SIDES: [Side, Point][] = [['top', { x: 0, y: -1 }], ['right', { x: 1, y: 0 }], ['bottom', { x: 0, y: 1 }], ['left', { x: -1, y: 0 }]];

export function plusButtons(o: OBB, zoom: number): { side: Side; at: Point }[] {
  const off = PLUS_OFFSET_PX / zoom;
  return SIDES.map(([side, n]) => ({ side, at: toWorld(o, { x: n.x * (o.w / 2 + off), y: n.y * (o.h / 2 + off) }) }));
}

export function plusAt(o: OBB, p: Point, zoom: number): Side | null {
  return plusButtons(o, zoom).find((b) => Math.hypot(b.at.x - p.x, b.at.y - p.y) <= PLUS_HIT_PX / zoom)?.side ?? null;
}
